/**
 * Convierte rutas de storage (relativas o con host local) a la origin del API.
 * Evita que "Ver / descargar" abra http://localhost/storage/... (puerto 80).
 */
export function resolverUrlArchivo(url, apiBaseUrl) {
  if (!url) return null;
  if (url.startsWith('data:') || url.startsWith('blob:')) return url;

  const apiOrigin = String(apiBaseUrl || '').replace(/\/api\/?$/, '');

  if (url.startsWith('http://') || url.startsWith('https://')) {
    try {
      const parsed = new URL(url);
      if (['localhost', '127.0.0.1'].includes(parsed.hostname)) {
        return `${apiOrigin}${parsed.pathname}${parsed.search}`;
      }
      return url;
    } catch (_) {
      return url;
    }
  }

  return `${apiOrigin}${url.startsWith('/') ? url : `/${url}`}`;
}
